import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=2da9e380&scoped=true&"
import script from "./privacy-policy.vue?vue&type=script&lang=js&"
export * from "./privacy-policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=2da9e380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9e380",
  null
  
)

export default component.exports